import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';

export function useCommoditySummary() {
  const { productService } = useService();

  const { data, isLoading, isFetching } = useQuery([QUERY_KEYS.commoditySummary], () =>
    productService.getGridSummary()
  );
  return { summary: data, isLoading, isFetching } as const;
}
